import {
  FETCH_MARKET_INFO_REQUEST,
  FETCH_MARKET_INFO_SUCCESS,
  FETCH_MARKET_INFO_FAILURE,
} from '../constants';

const initialState = {
  marketInfo: {
    isLoading: false,
    error: null,
    data: null,
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MARKET_INFO_REQUEST:
      return {
        ...state,
        marketInfo: {
          ...state.marketInfo,
          isLoading: true,
        }
      };

    case FETCH_MARKET_INFO_SUCCESS:
      return {
        ...state,
        marketInfo: {
          ...state.marketInfo,
          isLoading: false,
          data: action.payload,
        }
      };

    case FETCH_MARKET_INFO_FAILURE:
      return {
        ...state,
        marketInfo: {
          ...state.marketInfo,
          isLoading: false,
          error: action.payload,
        }
      };

    default:
      return state;
  }
};
